import React from 'react';
import {
  FaLaptopCode,
  FaMobileAlt,
  FaCode,
  FaLeaf,
  FaLightbulb,
  FaHandshake,
  FaTshirt,
  FaChartLine,
  FaNetworkWired,
} from 'react-icons/fa';

const Domains = () => {
  const domains = [
    {
      icon: <FaLaptopCode />,
      title: 'Informatique & solutions numériques',
      text: 'Développement de solutions informatiques complètes pour digitaliser les activités, optimiser les processus et créer de la valeur.',
    },
    {
      icon: <FaMobileAlt />,
      title: 'Applications web & mobiles',
      text: 'Conception d\'applications modernes, performantes et adaptées aux besoins réels des utilisateurs africains.',
    },
    {
      icon: <FaCode />,
      title: 'Logiciels & systèmes de gestion',
      text: 'Création de logiciels métiers et de systèmes de gestion pour simplifier le pilotage des activités et des ressources.',
    },
    {
      icon: <FaLeaf />,
      title: 'Agriculture & technologies agricoles',
      text: 'Solutions technologiques pour moderniser l\'agriculture, améliorer la productivité et faciliter le suivi des exploitations.',
    },
    {
      icon: <FaLightbulb />,
      title: 'Technologie & innovation',
      text: 'Veille technologique et développement de solutions innovantes adaptées au contexte local et aux réalités du terrain.',
    },
    {
      icon: <FaHandshake />,
      title: 'Sous-traitance & services professionnels',
      text: 'Prestations de services professionnels, expertises techniques et accompagnement des entreprises dans leurs projets.',
    },
    {
      icon: <FaTshirt />,
      title: 'Mode & style',
      text: 'Solutions digitales et accompagnement des acteurs de la mode, du style et des industries créatives en Afrique.',
    },
    {
      icon: <FaChartLine />,
      title: 'Solutions de gestion, suivi & traçabilité',
      text: 'Outils de gestion, de suivi et de pilotage pour une meilleure visibilité sur les activités, les stocks et les opérations.',
    },
    {
      icon: <FaNetworkWired />,
      title: 'Plateformes & services numériques',
      text: 'Conception de plateformes digitales qui connectent les personnes, les entreprises, les prestataires et les opportunités.',
    },
  ];

  return (
    <section id="secteurs" className="domains section section-alt">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Nos secteurs</span>
          <h2 className="section-title">Nos domaines d'intervention</h2>
          <p className="section-subtitle">
            Une expertise pluridisciplinaire au service du développement technologique,
            économique et social en Afrique.
          </p>
        </div>

        <div className="domains-grid">
          {domains.map((domain, index) => (
            <div className="domain-card" key={index}>
              <div className="domain-card-icon">{domain.icon}</div>
              <h3 className="domain-card-title">{domain.title}</h3>
              <p className="domain-card-text">{domain.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Domains;